/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/9/2
 * @updateTime 2021/9/2
 * @decription 选择申请人组件入口js
 */
import MeTitle from '@/components/common/meTitle';
// 标题栏
import acTitleBar from '@/components/app/title-bar/index.vue';
export default {
    name: 'selectSQR',
    // 混入
    mixins: [],
    // 依赖组件
    components: {
        MeTitle,
        acTitleBar
    },
    // 参数
    props: {
        // 选中的申请人id
        checkedId: Array,
        // 申请人数据列表
        data: Array
    },
    // 注入
    inject: ['fromSQBG'],
    // 数据
    data() {
        return {
            // 勾选的信息项数据
            checkedItem: null,
            // 勾选结果
            result: []
        };
    },
    // 计算属性
    computed: {},
    // 监听
    watch: {},
    // 创建完成
    created() {
        // 初始化方法
        this.init();
    },
    // 组件激活
    activated() {
    },
    // 组件初始化完成
    mounted() {
    },
    // 组件失去激活
    deactivated() {
    },
    // 销毁之前
    beforeDestroy() {
    },
    // 方法
    methods: {

        /**
         * 初始化方法
         * */
        init() {
            // 初始化勾选结果
            this.initResult();
        },

        /**
         * 初始化勾选的结果
         * */
        initResult() {
            const _result = [];
            const checkedIds = [...this.checkedId];
            // 申请人数据列表遍历
            (checkedIds && checkedIds.length) && this.data.every(sqrItem => {
                if (!checkedIds.length) {
                    return false;
                }
                // 索引
                const _index = checkedIds.indexOf(sqrItem[this.fromSQBG ? 'cYdbSqrid' : 'cId']);
                if (_index > -1) {
                    _result.push(sqrItem);
                    // 删除对应的id
                    checkedIds.splice(_index, 1);
                }
                return true;
            });
            // 默认选中值赋值
            this.result = _result;
        },

        /**
         * 点击取消
         * @returns {void}
         * */
        eClickCancel() {
            this.$emit('cancel');
        },

        /**
         * 点击选中
         * @param {Object} item 勾选的信息项
         * @param {Number} 勾选信息项索引
         * @returns {void}
         * */
        eClickChecked(item, index) {
            this.$refs.checkboxes[index].toggle();
        },

        /**
         * 点击了确认按钮
         * @returns {void}
         * */
        eClickConfirm() {
            this.$emit('confirm', this.result);
        }
    }
};
